export const homeObjOne = {
    id: 'about',
    lightBg: false, // background color
    lightText: true, // headline color
    lightTextDesc: true,
    topline: 'Sofia Jure',
    headline: 'Hair Artist',
    description: 'I have been a hairstylist for 6 years. I graduated from Aveda institute orlando. During that time I have gotten numerous certifications such as lash extension certification from fixe beauty, Redken color certification, and lastly Barbicide certification. During 2021 I decided to open up my own studio where I can provide services to clients in a safer and more relaxed environment.',
    buttonLabel: 'Get Started',
    imgStart: true, // this is for image first then words or other way
    //img: require('../../images/models/2.jpg'),
    alt: 'logo',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Sofia Jure',
    headline: 'Hair Artist',
    description: 'Sofia Description',
    buttonLabel: 'Get Started',
    imgStart: true, // this is for image first then words or other way
    //img: require('../../images/models/2.jpg'),
    alt: 'logo',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjThree = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Sofia Jure',
    headline: 'Hair Artist',
    description: 'Sofia Description',
    buttonLabel: 'Get Started',
    imgStart: true, // this is for image first then words or other way
    //img: require('../../images/models/2.jpg'),
    alt: 'logo',
    dark: true,
    primary: true,
    darkText: false
}